/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable no-restricted-globals */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-return */
import { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Divider, Grid } from '@mui/material';

import { GenericModalV2 } from 'components/shared';
import useSurveyQuestions from 'pages/Surveys/hooks/useSurveyQuestions';
import SurveyMutationCRUD from 'pages/Surveys/services/surveyMutationCRUD';

import QuestionBox from '../QuestionBox';
import TitleForm from '../TitleForm';

const styles = {
  createNewAuditModal: {
    maxHeight: 1025,
    height: '95%'
  },
  contentItems: {
    overflowY: 'auto',
    height: 'calc(80vh - 110px)'
  }
};

interface ModalSendFormSurveysProps {
  sendTicketId: number;
  isCreateAuditModalOpen: boolean;
  setCreateAuditModal: (open: boolean) => void;
  onCreateChange: (isCreate: boolean) => void
}

  // Definimos las interfaces para la estructura de datos
  interface Question {
    idSurveyQuestion: number;
    label: string;
    rating?: number; // opcional, ya que puede no estar presente
    select?: string; // opcional
    shortAnswer?: string; // opcional
    paragraph?: string; // opcional
  }
  
  interface StructuredData {
    title: string;
    description: string;
    questions: Question[];
  }
  
  interface StructuredData {
    title: string;
    description: string;
    questions: Question[];
  }
  
  interface Question {
    rating?: number;
    select?: string;
    shortAnswer?: string;
    paragraph?: string;
  }
  
  type QuestionTranform = {
    rating?: string | number;
    select?: string | number;
    shortAnswer?: string | number;
    paragraph?: string | number;
    idSurveyQuestion: number;
  };

function ModalSendFormSurveys({
  sendTicketId,
  isCreateAuditModalOpen,
  setCreateAuditModal,
  onCreateChange
}: ModalSendFormSurveysProps) {
  const { t } = useTranslation('global');

  const handleCancelModal = useCallback(() => {
    setCreateAuditModal(false);
  }, [setCreateAuditModal]);

  useEffect(() => {
    if(sendTicketId) {
        setCreateAuditModal(true); 
    }
  }, [sendTicketId])

  const {
    form,
    surveyQuestionsTicket,
    handleChangeSelected,
    handleChangeInputs,
    handleDragEnd,
    handleRemoveCard,
    handleRequired
  } = useSurveyQuestions({ IdTicket: sendTicketId });

  const { answerSurvey, isCreate } = SurveyMutationCRUD({});

const handleSubmit = (items: Record<string, string | number | undefined>) => {
  const structuredData: StructuredData = {
    title: items.title as string,
    description: items.description as string,
    questions: []
  };

  // Obtener el número de preguntas
  const labelKeys = Object.keys(items).filter(key => key.endsWith('-label'));

  labelKeys.forEach(labelKey => {
    const index = labelKey.split('-')[0]; // Obtener el número de la etiqueta
    const question: Question = {
      label: items[labelKey] as string
    };

    // Lista de posibles propiedades que una pregunta puede tener
    const questionProperties: Record<string, keyof Question> = {
      idSurveyQuestion: 'idSurveyQuestion',
      rating: 'rating',
      select: 'select',
      shortAnswer: 'shortAnswer',
      paragraph: 'paragraph'
    };

    // Iterar sobre las posibles propiedades de la pregunta
    Object.keys(questionProperties).forEach(prop => {
      const itemKey = `${index}-${prop}`;
      if (items[itemKey] !== undefined) {
        question[questionProperties[prop]] = items[itemKey] as any;
      }
    });

    // Solo agrega la pregunta si tiene una etiqueta
    if (question.label) {
      structuredData.questions.push(question);
    }
  });
  transformToAnswersValue(structuredData);
};

function transformToAnswersValue(structuredData?: { questions: QuestionTranform[] }) {
  if (!structuredData || !structuredData.questions) return [];

  const answersVaue = structuredData.questions.map(
    ({ rating, select, shortAnswer, paragraph, idSurveyQuestion }: Question) => {
      // Usar el primer valor definido entre rating, select, shortAnswer, o paragraph y convertirlo a string
      const value = String(rating ?? select ?? shortAnswer ?? paragraph ?? '');

      return {
        value,
        idSurveyQuestion: idSurveyQuestion ?? 0 // Usa 0 si idSurveyQuestion no está definido
      };
    }
  );
  answerSurvey.mutate({ idTicket: sendTicketId, answersVaue });
  return answersVaue; // Retorna el valor si se necesita usar
}

useEffect(() => {
  if (isCreate) {
    onCreateChange(isCreate);
  }
}, [isCreate]);

const titleModal = form.getValues('title');

  return (
    <GenericModalV2
      isOpen={isCreateAuditModalOpen}
      onClose={handleCancelModal}
      style={styles.createNewAuditModal}
      title={t('drawer.surveys.titleModal')}
    >
      <form onSubmit={form.handleSubmit(handleSubmit)} style={{ paddingBottom: '30px' }}>
      
          <TitleForm form={form} isEditable={false} titleModal={titleModal} />
          <Divider />
          <div style={styles.contentItems}>
            <QuestionBox 
              form={form}
              isEditable={false}
              onChangeInputs={handleChangeInputs}
              onChangeOption={handleChangeSelected}
              onDragEnd={handleDragEnd}
              onRemove={handleRemoveCard}
              onRequired={handleRequired}
              readOnly={false}
              surveyQuestions={surveyQuestionsTicket} />
          </div>

            <Grid
              justifyContent="space-evenly"
              marginTop={2}
              xs={12}
              container
              item
            >
              <Grid xs={5} item>
                <Button
                  color="primary"
                  onClick={() => {
                    handleCancelModal()
                  }}
                  variant="outlined"
                  fullWidth
                >
                  {t('common.commonActions.invalidate')}
                </Button>
              </Grid>
              <Grid xs={5} item>
                <Button
                  color="primary"
                  type="submit"
                  variant="contained"
                  fullWidth
                >
                  {t('common.commonActions.save')}
                </Button>
              </Grid>
            </Grid>
      </form>
    </GenericModalV2>
  );
}

export default ModalSendFormSurveys;
